import axios, { AxiosResponse } from 'axios';
import { LoggedUser, UserResponse } from '../types/usuarios/LoggedUser';

const SERV_BACK: string = process.env.REACT_APP_BACK || '';

//const SERV_BACK: string = 'http://192.168.253.6:8067';
const APIACCOUNT = '/api/Account';

export default class AccountService {

    // static async LoginInvestigacion(username: string): Promise<UserResponse> {
    //     const body = JSON.stringify({idapp :"" , netid: username });
    //     console.log(body);
    //     const response1: AxiosResponse<UserResponse> = await axios.post(`${SERV_BACK}${APIACCOUNT}`,
    //         body,
    //         {
    //             headers:{
    //                 "Content-type" : "application/json",
    //             },
    //         }
    //     );
    //     console.log(response1);

    //     return response1.data;
    // }

    static async LoginAyudantias(username: string): Promise<UserResponse> {
        const body = JSON.stringify({idapp :"" , netid: username });
        //console.log(body);
        const response1: AxiosResponse<UserResponse> = await axios.post(`${SERV_BACK}${APIACCOUNT}`,
            body,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        //console.log(response1);

        return response1.data;
    }



}